import {
  VERIFY_PLAYER,
  RETURNING_PLAYER,
  NEW_PLAYER,
  INITIATE_OTP,
  INITIATE_OTP_SUCCESS,
  INITIATE_OTP_FAILED,
  VERIFY_OTP,
  VERIFY_OTP_FAILED,
  STORE_OTP_TOKEN,
  ONBOARD_COMPLETED,
  SHOW_USERNAME_MODAL,
  RESET_ONBOARD,
  USSD_STARTED,
  SET_PLAYER_NETWORK,
  SUBSCRIBE_PLAYER_FAILED,
  SUBSCRIPTION_ERROR,
  USE_OTP
} from './actions';

const initialState = {
  progress: 'awaiting-player-number',
  player: {},
  subscribed: null,
  otp_token: '',
  ussd_await: false,
  player_network: '',
  error_msg: '',
  use_otp: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case VERIFY_PLAYER:
      return {
        ...state,
        progress: 'verify-player',
        ISD: action.meta.ISD,
        player: { ...state.player, msisdn: action.msisdn }
      };

    case RETURNING_PLAYER:
      return { ...state, progress: 'returning-player', subscribed: true };

    case NEW_PLAYER:
      return { ...state, progress: 'new-player', subscribed: false };

    case INITIATE_OTP:
      return { ...state, progress: 'OTP-initiated' };

    case INITIATE_OTP_SUCCESS:
      return { ...state, progress: 'awaiting-user' };

    case INITIATE_OTP_FAILED:
      return { progress: 'OTP-failed' };

    case VERIFY_OTP:
      return { ...state, progress: 'OTP-verification' };

    case VERIFY_OTP_FAILED:
      return { ...state, progress: 'invalid-OTP' };

    case STORE_OTP_TOKEN:
      return { ...state, otp_token: action.token };

    case ONBOARD_COMPLETED:
      return { ...state, progress: 'completed' };

    case SHOW_USERNAME_MODAL:
      return { ...state, progress: 'show-username-modal' };

    case RESET_ONBOARD:
      return { ...state, progress: '', ussd_await: false };

    case USSD_STARTED:
      return { ...state, ussd_await: true };

    case SET_PLAYER_NETWORK:
      return { ...state, player_network: action.network };

    case SUBSCRIBE_PLAYER_FAILED:
      return { ...state, ussd_await: false };

    case SUBSCRIPTION_ERROR:
      return { ...state, error_msg: action.msg };

    case USE_OTP:
      return { ...state, use_otp: action.status };

    default:
      return state;
  }
}
